import { render, staticRenderFns } from "./_embed.vue?vue&type=template&id=1877d93d&scoped=true"
import script from "./_embed.vue?vue&type=script&lang=js"
export * from "./_embed.vue?vue&type=script&lang=js"
import style0 from "./_embed.vue?vue&type=style&index=0&id=1877d93d&prod&lang=scss&scoped=true"
import style1 from "./_embed.vue?vue&type=style&index=1&id=1877d93d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877d93d",
  null
  
)

export default component.exports